if (process.env.NODE_ENV === 'production') {
  module.exports = require('./lib/react-input-mask.production.min.js');
} else {
  module.exports = require('./lib/react-input-mask.development.js');
}



//////////////////
// WEBPACK FOOTER
// ./~/react-input-mask/index.js
// module id = 2606
// module chunks = 0